









































import Vue from 'vue';
import { DocumentRepo, DocumentRepoStatus } from '@/utils/types/documentRepo/documentRepo';
import format from '@/utils/format';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'DocumentRepoCard',
  props: {
    item: Object as () => DocumentRepo,
  },
  computed: {
    documentRepoLink(): string {
      return `documentrepos/${this.item.id}`;
    },
  },
  methods: {
    ...mapActions('documentRepo', ['deleteDocumentRepo']),
    callDeleteDocumentRepo() {
      this.deleteDocumentRepo(this.item.id);
    },
    progressColor(status: DocumentRepoStatus): string {
      switch (status) {
        case 'finished': return 'is-success';
        case 'error': return 'is-danger';
        default: return 'is-info';
      }
    },
    progressValue(status: DocumentRepoStatus): number {
      switch (status) {
        case 'error': return 100;
        case 'initialized': return 5;
        case 'cloning': return 10;
        case 'parsing': return 25;
        case 'creating history': return 60;
        case 'finished': return 100;
        default: return 0;
      }
    },
  },
  filters: {
    getRepositoryNameFromGitURL: format.getRepositoryNameFromGitURL,
    getHostFromUrl: format.getHostFromURL,
  },
});
